/**
 * Dropdown menu
 */

import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'context/theme/themeContext';

import { Ul, Wrapper, H5, SubWrapper } from './elements';
import { useOnClickOutside, useWindowSize } from 'utils/hooks';

import { ReactComponent as Chevronright } from 'assets/icons/chevron_right.svg';
import { ReactComponent as Chevronleft } from 'assets/icons/chevron_left.svg';
import { ReactComponent as DownArrow } from 'assets/icons/arrow_drop_down.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as CloseWhite } from 'assets/icons/close_white.svg';

function Li({ children, id, activeItem, onClick }) {
  function handleOnclick() {
    if (typeof id !== 'string') {
      throw new Error('id must be a string');
    }
    if (typeof onClick === 'function') {
      onClick(id);
    }
  }
  return (
    <li id={id} className={activeItem === id ? 'active' : 'not-active'}>
      <div
        role="button"
        onClick={handleOnclick}
        onKeyDown={handleOnclick}
        tabIndex={0}
      >
        {children}
      </div>
    </li>
  );
}

Li.propTypes = {
  id: PropTypes.string.isRequired
};

export function DropdownMenu(props) {
  const { listOpacity, ...rest } = props;
  const ref = useRef();
  const [activeItem, setActiveItem] = useState('');
  const [opacity, setOpacity] = useState(0);
  const { width } = useWindowSize();
  const { themeMode } = useTheme();

  // This is an effect the closes the dropdown
  // when you click outside the dropdown when the
  // the dropdown is opened.
  useOnClickOutside(ref, () => {
    setOpacity(0);
    if (typeof props.handleClosing === 'function') {
      props.handleClosing();
    }
  });

  // useEffect(() => {
  //   if (Array.isArray(props.menuItems) && props.menuItems.length > 2) {
  //     setActiveItem(props.menuItems[0].id);
  //   }
  // }, [props.menuItems]);

  function handleOnClick() {
    setOpacity(opacity === 0 ? 1 : 0);
    if (typeof props.handleClosing === 'function' && opacity === 1) {
      props.handleClosing();
    }
  }

  function handleLiClick(evt, item) {
    if (props.width !== '100%' || props.subtitle) {
      setOpacity(opacity === 0 ? 1 : 0);
    }
    if (typeof item.id === 'string') {
      setActiveItem(item.id);
    }
    if (typeof item.onClick === 'function') {
      item.onClick(evt);
    }
  }

  return (
    <Wrapper ref={ref}>
      <button className="dropdown-btn" onClick={handleOnClick}>
        {width <= 768 && opacity === 1 ? (
          themeMode === 'dark' ? (
            <CloseWhite />
          ) : (
            <Close />
          )
        ) : (
          props.mainTitle
        )}
        {props.suffixIconDown ? <DownArrow /> : null}
      </button>
      <Ul top={props.top} opacity={opacity} width={props.width} {...rest}>
        {props.subtitle ? (
          <li className="sub-title">
            <SubWrapper>
              <h5>{props.subtitle}</h5>
              <button onClick={props.handleSubTitleClick}>
                {' '}
                <Chevronleft /> back to menu
              </button>
            </SubWrapper>
          </li>
        ) : null}
        {Array.isArray(props.menuItems) ? (
          props.menuItems.map(item => {
            return (
              <Li
                id={item.id}
                key={item.id}
                activeItem={activeItem}
                onClick={evt => handleLiClick(evt, item)}
              >
                <H5>
                  <span>
                    {item.icon ? (
                      <img src={item.icon} alt={`${item.title} icon`} />
                    ) : null}
                    <h5>{item.title}</h5>
                  </span>
                  {item.suffixIcon ? <Chevronright /> : null}
                </H5>
                <p style={{ paddingLeft: item.icon ? 34 : 0, lineHeight: 1.5 }}>
                  {item.description || null}
                </p>
              </Li>
            );
          })
        ) : (
          <p>Add menu items</p>
        )}
      </Ul>
    </Wrapper>
  );
}

DropdownMenu.defaultProps = {
  top: 70,
  width: 230
};

DropdownMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  mainTitle: PropTypes.any.isRequired,
  top: PropTypes.number,
  width: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ])
};

export default DropdownMenu;
